@import (reference) '../../../../../constants/spacing.module.less';

.card {
  padding: @space-16;
  border-radius: 4px;
  border: 1px solid var(--grey-300);
  background-color: var(--white);
  width: 100%;
}

.header {
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.controls {
  align-items: center;
}

.divider {
  border-color: var(--grey-200);
}
